import React, {Component} from "react";
import Select, { ActionMeta, OptionsType } from "react-select";
import {connect} from "react-redux";
import { fetchReferrers } from "../../../../store/slices/admin/referrers";
import { fetchReferrerTypes } from "../../../../store/slices/admin/referrerTypes";
import { debounce, DebouncedFunc, isEqual } from "lodash";

type Props = {
    isEdit: boolean,
    cellId: number,
    id: number,
    updateConfig: Function,
    // injected
    dispatch: Function,
    brands: Array<string>,
    referrerData: Array<any>,
    referrerTypeData: Array<any>,
    isLoadingReferrers: boolean,
    isLoadingReferrerTypes: boolean,
    isDisabled: boolean,
    referrers: Array<string>
    referrerTypes: Array<string>
}

type OptionType = {
    value: string;
    label: string;
};

type State = {
    searchedReferrers: OptionType[],
    initialReferrersLoaded: boolean
}

class Referrers extends Component<Props, State> {
    getReferrerOptions: DebouncedFunc<(inputValue: string) => void>;

    constructor(props: Props) {
        super(props);

        this.getReferrerOptions = debounce(this._getReferrerOptions, 400);

        this.state = {
            searchedReferrers: [],
            initialReferrersLoaded: false
        };

        this.onReferrerChange = this.onReferrerChange.bind(this);
        this.onReferrerTypeChange = this.onReferrerTypeChange.bind(this);
    }


    componentDidMount() {
        if (this.props.brands.length) {
            const brands = this.props.brands.join(',');
            this.props.dispatch(fetchReferrerTypes(brands, this.props.cellId));
        }
    }

    componentDidUpdate(prevProps: Props): void {
        const brands = this.props.brands.join(',');

        if (prevProps.isDisabled === false && this.props.isDisabled === true) {
            this.props.updateConfig(["referrers"], [[]]);
        }

        if (!isEqual(prevProps.brands, this.props.brands)) {
            this.fetchInitialReferrers(brands);

            if (this.props.brands.length > 0) {
                this.props.dispatch(fetchReferrerTypes(brands, this.props.cellId));
            }
        }
    }

    _getReferrerOptions = (inputValue: string) => {
        if (inputValue && this.props.brands.length > 0) {
            const brands = this.props.brands.join(',');
            this.props.dispatch(fetchReferrers(brands, inputValue, this.props.cellId))
                .then(() => {
                    this.setState({
                        searchedReferrers: this.props.referrerData[this.props.cellId],
                        initialReferrersLoaded: false
                    });
                });
        }
    };

    onReferrerChange(value: OptionsType<{ value: string; label: string; }>) {
        this.props.updateConfig(["referrers"], [(!value || value.length < 1) ? [] : value.map(item => item.value)]);
    }

    onReferrerTypeChange(value: OptionsType<{ value: string; label: string; }>, actionMeta: ActionMeta<{ value: string; label: string; }>) {
        this.props.updateConfig(["referrer_types"], [(!value || value.length < 1) ? [] : value.map(item => item.value)]);
    }

    onReferrerBlur = (_: React.FocusEvent<HTMLElement>) => {
        if (this.props.isLoadingReferrers || this.state.initialReferrersLoaded) {
            return;
        }

        this.fetchInitialReferrers(this.props.brands.join(','));
    }

    fetchInitialReferrers = (brands: string) => {
        this.props.dispatch(fetchReferrers(brands, "", this.props.cellId)).then(() => {
            this.setState({ 
                initialReferrersLoaded: true, 
                searchedReferrers: this.props.referrerData[this.props.cellId],
            });
        });
    }

    referrerValues = () => {
        if (this.props.referrers && this.props.referrers.length > 0) {
            return this.props.referrers.map(referrer => {
                return {
                    value: referrer,
                    label: referrer
                };
            });
        }

        return null;
    }

    referrerTypeValues = () => {
        if (this.props.referrerTypes && this.props.referrerTypes.length > 0) {
            return this.props.referrerTypes.map(referrerType => {
                let label = referrerType.replaceAll(/_|-/g, ' ');

                if (label.indexOf('.') === -1) {
                    label = label.charAt(0).toUpperCase() + label.slice(1);
                }
                return {
                    value: referrerType,
                    label: label
                };
            });
        }

        return null;
    }
   
    render() {
        return (
            <div className="config-item__selects">

                <div className="form-group">
                    <label htmlFor="referrer">Referrer:</label>
                    <Select
                        id="referrers"
                        className="basic-single"
                        classNamePrefix="so-select-sort"
                        isSearchable={true}
                        isMulti
                        value={this.referrerValues()}
                        options={this.props.isLoadingReferrers ? [] : this.state.searchedReferrers}
                        onChange={this.onReferrerChange}
                        onInputChange={this.getReferrerOptions}
                        closeMenuOnSelect={false}
                        onBlur={this.onReferrerBlur}
                        placeholder={<div>Type to search</div>}
                        isLoading={this.props.isLoadingReferrers}
                        isDisabled={this.props.isDisabled}
                        menuPortalTarget={document.body}
                        styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                    />
                </div>

                <div className="form-group">
                    <label htmlFor="referrer">Referrer type:</label>
                    <Select
                        id="referrer-types"
                        className="basic-single"
                        classNamePrefix="so-select-sort"
                        isSearchable={true}
                        isMulti
                        value={this.referrerTypeValues()}
                        options={this.props.isLoadingReferrerTypes ? [] : this.props.referrerTypeData[this.props.cellId]}
                        onChange={this.onReferrerTypeChange}
                        isLoading={this.props.isLoadingReferrerTypes}
                        isDisabled={this.props.isDisabled}
                        menuPortalTarget={document.body}
                        styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                    />
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state: any) => {
    return {
        isLoadingBrands: state.brands.isLoading,
        referrerData: state.referrers ? state.referrers.data : [],
        referrerTypeData: state.referrerTypes ? state.referrerTypes.data : [],
        isLoadingReferrers: state.referrers ? state.referrers.isLoading : false,
        isLoadingReferrerTypes: state.referrerTypes ? state.referrerTypes.isLoading : false,
    }
};

export default connect(mapStateToProps)(Referrers);
